import { CLIENT_TYPE_WEB } from 'viewup-lib/common';

type RequestDefaults = object;

export type RequestWithDefaults<TRequest extends object, TDefaults extends RequestDefaults> = Omit<
  TRequest,
  keyof TDefaults
> &
  Partial<Pick<TRequest, Extract<keyof TRequest, keyof TDefaults>>>;

export const createRequestDefaultMapper = <const TDefaults extends RequestDefaults>(
  defaults: TDefaults,
) => {
  return <TRequest extends object>(
    request?: RequestWithDefaults<TRequest, TDefaults>,
  ): TRequest => {
    return {
      ...defaults,
      ...(request ?? {}),
    } as unknown as TRequest;
  };
};

const serviceRequestDefaults = {
  xClientType: CLIENT_TYPE_WEB,
};

export type ServiceRequest<TRequest extends object> = RequestWithDefaults<
  TRequest,
  typeof serviceRequestDefaults
>;

export const withServiceRequestDefaults = createRequestDefaultMapper(serviceRequestDefaults);
